import {createSelector} from '@ngrx/store';
import {AppState} from 'src/app/state/app.state';
import {BuildingState, LocationState, MeterState, UserState} from 'src/app/state/reducers';

const selectBuildingState = (state: AppState): BuildingState => state.building;
const selectMeterState = (state: AppState): MeterState => state.meter;
const selectUserState = (state: AppState): UserState => state.user;
const selectLocationState = (state: AppState): LocationState => state.location;

export const selectBuilding = createSelector(selectBuildingState, (state: BuildingState) => state);
export const selectMeter = createSelector(selectMeterState, (state: MeterState) => state);
export const selectUser = createSelector(selectUserState, (state: UserState) => state);
export const selectLocation = createSelector(selectLocationState, (state: LocationState) => state);
